import React, { useState, useEffect } from "react";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import ProgressBar from "react-bootstrap/ProgressBar";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import TokenSlide from "./tokenSlide";

export default function Promotions() {
  const [tokenSold, setTokenSold] = useState(0);
  const [presaleInfiBalance, setPresaleInfiBalance] = useState(0);
  const now = 60;

  return (
    <>
      <Header />
      <div className="bg-darkgrey">
        <section className="privacypolicy py-5 ">
          <Container>
            <Row>
              <Col
                xl={3} lg={6} md={6}
                className={`cardStyle position-relative z-2 position-relative mb-4`}
              >
                    <TokenSlide/>

                {/* <div className="social-icon socialBox mb-0 text-black ">
                    <ul className="mb-0 py-3">
                      <li>
                        <a href="#">
                          <img
                            src="assets/images/ico/icon/bitcoin.png"
                            alt=""
                          />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <img
                            src="assets/images/ico/icon/litecoin.png"
                            alt=""
                          />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <img
                            src="assets/images/ico/icon/chainlink.png"
                            alt=""
                          />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <img
                            src="assets/images/ico/icon/siacoins.png"
                            alt=""
                          />
                        </a>
                      </li>
                    </ul>
                  </div> */}
              </Col>

              <Col
                xl={3} lg={6} md={6}
                className={`cardStyle position-relative z-2 position-relative mb-4`}
              >
                <TokenSlide/>
              </Col>
               <Col
                xl={3} lg={6} md={6}
                className={`cardStyle position-relative z-2 position-relative mb-4`}
              >
                <TokenSlide/>
              </Col>
               <Col
                xl={3} lg={6} md={6}
                className={`cardStyle position-relative z-2 position-relative mb-4`}
              >
                <TokenSlide/>
              </Col>
               <Col
                xl={3} lg={6} md={6}
                className={`cardStyle position-relative z-2 position-relative mb-4`}
              >
                <TokenSlide/>
              </Col>
               <Col
                xl={3} lg={6} md={6}
                className={`cardStyle position-relative z-2 position-relative mb-4`}
              >
                <TokenSlide/>
              </Col>
               <Col
                xl={3} lg={6} md={6}
                className={`cardStyle position-relative z-2 position-relative mb-4`}
              >
                <TokenSlide/>
              </Col>
               <Col
                xl={3} lg={6} md={6}
                className={`cardStyle position-relative z-2 position-relative mb-4`}
              >
                <TokenSlide/>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
      <Footer />
    </>
  );
}
